import { AHText, Box, StoreFormattedDate } from "arkh";

import { FormattedMessage } from "react-intl";
import { StoreAdminNavigationProp } from "../StoreAdmin/StoreAdminNavigation";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { IntegrationActivateScreen } from "./components/IntegrationActivation";
import { Linking, Platform } from "react-native";
import { IntegrationICAScreenMutation } from "./__generated__/IntegrationICAScreenMutation.graphql";
import QRCode from "react-native-qrcode-svg";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import { IntegrationICAScreenQuery } from "./__generated__/IntegrationICAScreenQuery.graphql";

export function IntegrationICAScreen(props: {
  navigation: StoreAdminNavigationProp<"IntegrationICAScreen">;
}) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fkk) => <IntegrationICAScreenC {...props} fetchKey={fkk} />}
    </LazyQueryNetworkBoundrary>
  );
}
function IntegrationICAScreenC(props: {
  navigation: StoreAdminNavigationProp<"IntegrationICAScreen">;
  fetchKey: string;
}) {
  const [mutation, mutationLoading] = useMutation<IntegrationICAScreenMutation>(
    graphql`
      mutation IntegrationICAScreenMutation {
        store {
          activateIntegrationICAMinButikInitiate {
            url
            integration {
              authRequests {
                expiresAtDate {
                  ...StoreFormattedDate
                }
                link
              }
            }
          }
        }
      }
    `
  );

  const data = useLazyLoadQuery<IntegrationICAScreenQuery>(
    graphql`
      query IntegrationICAScreenQuery {
        store {
          integrationICAMinButik {
            authRequests {
              expiresAtDate {
                ...StoreFormattedDate
              }
              link
            }
          }
        }
      }
    `,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );
  function create() {
    mutation({
      variables: {},
      onCompleted: (data) => {
        if (data.store.activateIntegrationICAMinButikInitiate) {
          if (Platform.OS === "web") {
          } else {
            Linking.openURL(
              data.store.activateIntegrationICAMinButikInitiate.url
            );
            props.navigation.goBack();
          }
        }
      },
    });
  }
  const loading = mutationLoading;

  return (
    <IntegrationActivateScreen
      onActivate={create}
      isActivating={loading}
      isValid={!!true}
      header={
        <IntegrationActivateScreen.Header
          logo={
            <AHText type="title">
              <FormattedMessage
                description="IntegrationsAdminICA create screen title"
                defaultMessage="ICA Min Butik"
              />
            </AHText>
          }
        />
      }
      activation={
        <>
          <AHText>
            Genom aktivering bekräftar jag att jag har behörighet och mandat att
            autentisera denna webbplats för delning av data med StoreSprint.
            StoreSprint behandlar all data i enlighet med gällande
            dataskyddslagstiftning och med högsta säkerhetsstandard. Klicka på
            aktivera för att gå vidare.
          </AHText>
          <Box space="medium" style={{ flexDirection: "row" }}>
            {data.store.integrationICAMinButik?.authRequests?.map(
              (authRequest) =>
                authRequest.link ? (
                  <Box key={authRequest.link} space="medium">
                    <Box
                      space="medium"
                      color="surface-primary"
                      borderColor="border-primary"
                      cornerRadius="large"
                      style={{
                        borderWidth: 1,
                      }}
                    >
                      <QRCode value={authRequest.link} size={200} />
                      {authRequest.expiresAtDate ? (
                        <AHText>
                          <StoreFormattedDate
                            date={authRequest.expiresAtDate}
                          />
                        </AHText>
                      ) : null}
                    </Box>
                  </Box>
                ) : null
            )}
          </Box>
        </>
      }
    />
  );
}
